import { gql } from '@apollo/client';

import { MatchupVoteResultsFields } from './fragments';

export const GENERATE_MATCHUP_INVITE_TOKEN = gql`
  mutation GenerateMatchupInviteToken {
    generateMatchupInviteToken
  }
`;

export const ACCEPT_MATCHUP_INVITE = gql`
  mutation AcceptMatchupInvite($input: AcceptMatchupInviteInput!) {
    acceptMatchupInvite(input: $input) {
      id
      streamId
    }
  }
`;

export const DECLARE_MATCHUP_WINNER = gql`
  mutation DeclareMatchupWinner($input: DeclareMatchupWinnerInput!) {
    declareMatchupWinner(input: $input) {
      id
      winnerCorner
    }
  }
`;

export const VOTE_MATCHUP = gql`
  mutation VoteMatchup($input: VoteMatchupInput!) {
    voteMatchup(input: $input) {
      ...MatchupVoteResultsFields
    }
  }
  ${MatchupVoteResultsFields}
`;

// Triggers backend (APITemplate) generation of the fan "share your pick"
// graphic and returns the ImageGenerationJob id to poll via
// CHECK_GENERATION_JOB_STATUS. Requires the caller to have voted and the
// stream's sharePickGraphicsEnabled flag to be on.
export const TRIGGER_MATCHUP_SHARE_PICK_GRAPHIC = gql`
  mutation TriggerMatchupSharePickGraphic(
    $input: TriggerMatchupSharePickInput!
  ) {
    triggerMatchupSharePickGraphic(input: $input)
  }
`;
